import React from 'react';
import SvgIcon from './SvgIcon';

const Fire = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path d="M.75 12h16.5v11.25H.75V12z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M17.25 19.5a6 6 0 006-6c0-4.275-1.5-6.75-1.5-6.75.258 1.029.359 2.09.3 3.15a9.3 9.3 0 01-1.65 4.912c.6-1.124.412-5.1-.9-8.062-1.313-2.962-3.713-4.388-6-6 2.1 1.612 2.812 4.575 2.4 6.9A10.314 10.314 0 0114.175 12s.9-1.463.15-3.75a5.775 5.775 0 00-2.325-3c3 3.037.112 3.412-.6 6.75M12.75 19.5v3.75m-12-7.5h16.5H.75zm0 3.75h16.5H.75zM9 15.75v3.75-3.75zM5.25 12v3.75V12zm7.5 0v3.75V12zm-7.5 7.5v3.75-3.75z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

Fire.displayName = 'FireIcon';

export default Fire;
